<template>
  <ValidationObserver ref="customerForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions" class="mb-6">
      <v-form rel="customerForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 mb-6 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.name"
                  rules="required"
                  outlined
                  dense
                  label="Název"
                  data-cy="name"
                  maxlength="70"
                  counter
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.promoCodeApplyCount"
                  rules="required"
                  type="number"
                  min="1"
                  outlined
                  dense
                  label="Počet promo kódů v rámci objednávky"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.campaignId"
                  outlined
                  dense
                  label="Id kampaně - mailkit"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.campaignListId"
                  outlined
                  dense
                  label="Id seznamu příjemců - mailkit"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.guideLink"
                  outlined
                  dense
                  label="Url návod na aktivaci"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <!--            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VDatePickerWithValidation
                  v-model="value.validUntil"
                  rules="required"
                  date-format="dd.MM.yyyy"
                  outlined
                  dense
                  label="Platnost od"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VDatePickerWithValidation
                  v-model="value.validTo"
                  rules="required"
                  date-format="dd.MM.yyyy"
                  outlined
                  dense
                  label="Platnost do"
                />
              </v-col>
            </v-row>-->
          </v-card-text>
          <v-card-actions class="pa-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Uložit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'GiftForm',
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    saving: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
    }
  },
  methods: {
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
